import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Nav, Offcanvas } from "react-bootstrap";
import {
  Menu,
  X,
  User,
  Search,
  Heart,
  ArrowRight,
  ChevronDown,
  ChevronRight,
} from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
  FaPinterest,
} from "react-icons/fa";
import { useSiteConfig } from "../context/SiteConfigContext";
import categoryApi from "../api/categoryApi";
import SearchCanvas from "../Pages/canvas/SearchCanvas";
const Header = () => {
  const { siteConfig } = useSiteConfig();
  const [category, setCategory] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);

  // Mobile hamburger menu state
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [openMobileCategory, setOpenMobileCategory] = useState(null);
  const handleOpenMobileMenu = () => setShowMobileMenu(true);
  const handleCloseMobileMenu = () => setShowMobileMenu(false);
  const toggleMobileCategory = (id) => {
    setOpenMobileCategory((prev) => (prev === id ? null : id));
  };

  // Mobile search state (separate from desktop, avoids conflict)
  const [mobileSearchText, setMobileSearchText] = useState("");
  const [showMobileSearchModal, setShowMobileSearchModal] = useState(false);

  useEffect(() => {
    fetchCategory();
  }, []);

  const applyData = (result) => {
    setCategory(result?.category || []);
  };
  const CACHE_TIME = 3 * 60 * 1000;

  const fetchCategory = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;

      if (parsed?.data) {
        applyData(parsed.data);
      }

      const isExpired = !parsed || Date.now() - parsed.timestamp > CACHE_TIME;

      if (isExpired) {
        const res = await categoryApi.list();

        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({
              data: res.data,
              timestamp: Date.now(),
            }),
          );

          applyData(res.data);
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };
  const categoryInfo = category[0];

  return (
    <>
      <header className="custom-header-wrapper">
        {/* ===== TOP STRIP ===== */}
        <div className="custom-header-top container-fluid px-md-5 px-3 py-2">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="header-top-tagline">
              <Heart size={13} className="me-2" />
              <span>
                {siteConfig?.tagline ||
                  "Nature's Beauty. Timeless Energy. Curated for You."}
              </span>
              <ArrowRight size={13} className="ms-2" />
            </div>

            <div className="d-flex align-items-center gap-3 social-header">
              {siteConfig?.facebook && (
                <a
                  href={siteConfig?.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaFacebook />
                </a>
              )}
              {siteConfig?.instagram && (
                <a
                  href={siteConfig?.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaInstagram />
                </a>
              )}
              {siteConfig?.pinterest && (
                <a
                  href={siteConfig?.pinterest}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaPinterest />
                </a>
              )}
              {siteConfig?.twitter && (
                <a
                  href={siteConfig?.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaTwitter />
                </a>
              )}
              {siteConfig?.youtube && (
                <a
                  href={siteConfig?.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaYoutube />
                </a>
              )}
              {siteConfig?.linkedin && (
                <a
                  href={siteConfig?.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link"
                >
                  <FaLinkedin />
                </a>
              )}
              <ArrowRight
                size={14}
                className="social-arrow-end d-none d-md-inline"
              />
            </div>
          </div>
        </div>

        {/* ===== MAIN HEADER LAYER ===== */}
        <div className="custom-header-main-layer py-2">
          <Container fluid className="px-md-5 px-3">
            <div className="custom-header-flex">
              {/* LEFT - LOGO (desktop) */}
              <div className="custom-header-left d-none d-lg-flex">
                <Link to="/" className="custom-header-logo">
                  <img
                    src={siteConfig?.logo}
                    alt={siteConfig?.siteName || "logo"}
                  />
                </Link>
              </div>

              {/* MOBILE - HAMBURGER (left) */}
              <div className="custom-mobile-left d-lg-none">
                <button
                  type="button"
                  onClick={handleOpenMobileMenu}
                  className="custom-mobile-menu-btn"
                  aria-label="Open Menu"
                >
                  <Menu size={24} />
                </button>
              </div>

              {/* CENTER - LOGO (mobile only) */}
              <div className="custom-header-center d-lg-none">
                <Link to="/" className="custom-header-logo">
                  <img
                    src={siteConfig?.logo}
                    alt={siteConfig?.siteName || "logo"}
                  />
                </Link>
              </div>

              {/* RIGHT - ICONS (desktop) */}
              <div className="custom-header-right d-none d-lg-flex align-items-center">
                {/* <div className="custom-header-search-box">
                  <Search size={18} className="search-static-icon" />
                  <input
                    type="text"
                    className="premium-search-input"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setShowSearchModal(true);
                    }}
                    onFocus={() => setShowSearchModal(true)}
                  />
                  <SearchCanvas
                    isOpen={showSearchModal}
                    searchText={searchText}
                    setSearchText={setSearchText}
                  />
                </div> */}

                {/* {isLoggedIn ? (
                  <Link to="/users/dashboard" className="custom-header-link user-icon-link">
                    <User size={18} />
                  </Link>
                ) : (
                  <Link to="/users/login" className="custom-header-link user-icon-link">
                    <User size={18} />
                  </Link>
                )} */}

                <Nav>
                  <Nav.Link as={Link} to="/" className="custom-nav-item">
                    Home
                  </Nav.Link>

                  <div className="custom-nav-dropdown">
                    <Nav.Link
                      as={Link}
                      to="/categories"
                      className="custom-nav-item"
                    >
                      Category
                      <ChevronDown size={12} className="nav-caret" />
                    </Nav.Link>

                    <div className="custom-dropdown-menu">
                      {category.map((cat) => (
                        <div className="dropdown-subitem-wrapper" key={cat._id}>
                          <Link
                            to={`/categories/${cat.slug}`}
                            className="custom-dropdown-item"
                          >
                            {cat.name}
                            {cat.children && cat.children.length > 0 && (
                              <ChevronRight
                                size={12}
                                className="submenu-caret"
                              />
                            )}
                          </Link>

                          {cat.children && cat.children.length > 0 && (
                            <div className="custom-dropdown-submenu">
                              {cat.children.map((sub) => (
                                <Link
                                  key={sub._id}
                                  to={`/categories/${sub.slug}`}
                                  className="custom-dropdown-item"
                                >
                                  {sub.name}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className="custom-nav-item"
                  >
                    About
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className="custom-nav-item"
                  >
                    Contact
                  </Nav.Link>
                </Nav>
              </div>

              {/* MOBILE - RIGHT (login/dashboard icon only) */}
              {/* <div className="custom-mobile-right d-lg-none">
                {isLoggedIn ? (
                  <Link to="/users/dashboard" className="mobile-user-icon-link" aria-label="Dashboard">
                    <User size={20} />
                  </Link>
                ) : (
                  <Link to="/users/login" className="mobile-user-icon-link" aria-label="Login">
                    <User size={20} />
                  </Link>
                )}
              </div> */}
            </div>
          </Container>
        </div>

        {/* ===== MOBILE SEARCH BOX ===== */}
        {/* <div className="custom-header-search-box custom-header-search-box--mobile d-flex d-lg-none">
          <Search size={17} className="search-static-icon" />
          <input
            type="text"
            className="premium-search-input"
            placeholder="Search crystals..."
            value={mobileSearchText}
            onChange={(e) => {
              setMobileSearchText(e.target.value);
              setShowMobileSearchModal(true);
            }}
            onFocus={() => setShowMobileSearchModal(true)}
          />
          <SearchCanvas
            isOpen={showMobileSearchModal}
            searchText={mobileSearchText}
            setSearchText={setMobileSearchText}
          />
        </div> */}

      </header>

      {/* ===== MOBILE HAMBURGER MENU (Offcanvas) ===== */}
      <Offcanvas
        show={showMobileMenu}
        onHide={handleCloseMobileMenu}
        placement="start"
        className="custom-mobile-offcanvas"
      >
        <Offcanvas.Header className="custom-mobile-offcanvas-header">
          <Link
            to="/"
            className="custom-header-logo"
            onClick={handleCloseMobileMenu}
          >
            <img
              src={siteConfig?.logo}
              alt={siteConfig?.siteName || "logo"}
            />
          </Link>
          <button
            type="button"
            className="custom-mobile-offcanvas-close"
            aria-label="Close Menu"
            onClick={handleCloseMobileMenu}
          >
            <X size={22} />
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body className="custom-mobile-offcanvas-body">
          <Nav className="flex-column custom-mobile-nav">
            <Nav.Link
              as={Link}
              to="/"
              className="custom-mobile-nav-item"
              onClick={handleCloseMobileMenu}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/about-us"
              className="custom-mobile-nav-item"
              onClick={handleCloseMobileMenu}
            >
              About
            </Nav.Link>

            <div className="custom-mobile-nav-dropdown">
              <div className="custom-mobile-nav-item custom-mobile-category-toggle">
                <Link
                  to="/categories"
                  className="custom-mobile-category-link"
                  onClick={handleCloseMobileMenu}
                >
                  Category
                </Link>
                {category.length > 0 && (
                  <button
                    type="button"
                    className="custom-mobile-category-caret"
                    aria-label="Toggle category list"
                    onClick={() => toggleMobileCategory("root")}
                  >
                    <ChevronDown
                      size={16}
                      className={
                        openMobileCategory === "root" ? "rotate-open" : ""
                      }
                    />
                  </button>
                )}
              </div>

              {openMobileCategory === "root" && (
                <div className="custom-mobile-submenu">
                  {category.map((cat) => (
                    <div className="custom-mobile-subitem" key={cat._id}>
                      <div className="custom-mobile-category-toggle">
                        <Link
                          to={`/categories/${cat.slug}`}
                          className="custom-mobile-category-link custom-mobile-category-link--sub"
                          onClick={handleCloseMobileMenu}
                        >
                          {cat.name}
                        </Link>
                        {cat.children && cat.children.length > 0 && (
                          <button
                            type="button"
                            className="custom-mobile-category-caret"
                            aria-label={`Toggle ${cat.name}`}
                            onClick={() => toggleMobileCategory(cat._id)}
                          >
                            <ChevronRight
                              size={14}
                              className={
                                openMobileCategory === cat._id
                                  ? "rotate-open-right"
                                  : ""
                              }
                            />
                          </button>
                        )}
                      </div>

                      {cat.children &&
                        cat.children.length > 0 &&
                        openMobileCategory === cat._id && (
                          <div className="custom-mobile-subsubmenu">
                            {cat.children.map((sub) => (
                              <Link
                                key={sub._id}
                                to={`/categories/${sub.slug}`}
                                className="custom-mobile-subsubitem"
                                onClick={handleCloseMobileMenu}
                              >
                                {sub.name}
                              </Link>
                            ))}
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Nav.Link
              as={Link}
              to="/contact-us"
              className="custom-mobile-nav-item"
              onClick={handleCloseMobileMenu}
            >
              Contact
            </Nav.Link>
          </Nav>

          <div className="custom-mobile-offcanvas-footer">
            <span className="custom-mobile-offcanvas-tagline">
              {siteConfig?.tagline ||
                "Nature's Beauty. Timeless Energy. Curated for You."}
            </span>
            <div className="d-flex align-items-center gap-3 custom-mobile-social">
              {siteConfig?.facebook && (
                <a
                  href={siteConfig?.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaFacebook />
                </a>
              )}
              {siteConfig?.instagram && (
                <a
                  href={siteConfig?.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaInstagram />
                </a>
              )}
              {siteConfig?.pinterest && (
                <a
                  href={siteConfig?.pinterest}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaPinterest />
                </a>
              )}
              {siteConfig?.twitter && (
                <a
                  href={siteConfig?.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaTwitter />
                </a>
              )}
              {siteConfig?.youtube && (
                <a
                  href={siteConfig?.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaYoutube />
                </a>
              )}
              {siteConfig?.linkedin && (
                <a
                  href={siteConfig?.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-header-link social-header-link--dark"
                >
                  <FaLinkedin />
                </a>
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
